module.exports = __webpack_public_path__ + "assets/img/cloudIsland.svg";